var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isItems
    ? _c(
        "emd-card",
        [
          _c(
            "emd-card-header",
            [
              _c("emd-text", { attrs: { size: "section" } }, [
                _vm._v(" " + _vm._s(_vm.$t("header"))),
              ]),
            ],
            1
          ),
          _c(
            "emd-card-content",
            _vm._l(_vm.data, function (item, idx) {
              return _c(
                "emd-text-section",
                { key: idx, attrs: { title: `Item ${item.number}` } },
                [
                  _c("emd-text-content", {
                    attrs: { title: _vm.$t("name"), content: item.name },
                  }),
                  _c("emd-text-content", {
                    attrs: {
                      title: _vm.$t("description"),
                      content: item.description,
                    },
                  }),
                  _c("emd-text-content", {
                    attrs: {
                      title: _vm.$t("quantity"),
                      content: item.quantity,
                    },
                  }),
                  _c("emd-text-content", {
                    attrs: { title: _vm.$t("amount"), content: item.amount },
                  }),
                  _c("emd-text-content", {
                    attrs: {
                      title: _vm.$t("totalAmount"),
                      content: item.totalAmount,
                    },
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }